// extracted by mini-css-extract-plugin
module.exports = {"profilePageContainer":"_3-zJs","mainContainer":"_31U07","detailsCardContainer":"_1FX5W","expertDataContainer":"cVhwy","emptyState":"_2pk90","imageContainer":"Ftq8z"};